import React, { useEffect, useState } from "react";
import {
  Table, Card,
  Select, useDispatch,
  useSelector, Form, Input, Switch, Button, Drawer,Modal,Divider,
  DeleteFilled, EditFilled, SearchOutlined, UserAddOutlined, Tree, message, Popconfirm,Tooltip,EyeOutlined
} from '../../AntComponent';
import { addUserGroup, associateServices, changeGroupStatus, deleteUserGrp, roleMenuService, userGroupGrid } from "../../../store/actions/security/userGroupAction";
import ViewUserGroup from "./sub-tabs/ViewUserGroup";
import { userTypeRoleDpdn } from "../../../store/actions/security/serviceRefAction";

const { TextArea } = Input;
const { TreeNode } = Tree;

export default function PermissionManagement() {
  const [form] = Form.useForm();
  const[openModal,setOpenModal]=useState(false);
  const { groupTableData, roleMenuInfo, success4,addGroupInfo, loading, success6, assSrvInfo, success9, delGrpInfo } = useSelector(state => state.userGroup);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const totalPage = groupTableData ? groupTableData?.data?.serverSearchables?.recordsTotal : 0;
  const [searchTableVal, setSearchTableVal] = useState("");
  const [sortField, setSortField] = useState("UserGroupID");
  const [sortOrder, setSortOrder] = useState("Desc");
  const { profileInfo } = useSelector(state => state.userPrf);
  const tenantID = profileInfo?.data?.appUser?.tenantID;
  const appUserID = profileInfo?.data?.appUser?.appuserID;
  const productID = profileInfo?.data?.tenantDetail?.kProductID;
  const [gStatus, setGstatus] = useState(true);
  const [roleID, setRoleID] = useState(0);
  const [newUgroup, setNewUgroup] = useState();

  const dispatch = useDispatch();
  const { typeRoleDpd } = useSelector(state => state.serviceRef);

  const [open, setOpen] = useState(false);
  const tableData = groupTableData ? groupTableData?.data?.userGrpOrderLists : [];
  const [isDefault, setIsDefault] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [rowData, setRowData] = useState(null);
  const [roleOptions, setRoleOptions] = useState([]);
  const [openStatus, setOpenStatus] = useState(false);
  const [groupStatus, setGroupStatus] = useState(true);
  const [selectedService, setSelectedService] = useState([]);
  const [userGroupID, setUserGroupID] = useState(0);
  const [showSuccessmsg, setShowsuccessmsg] = useState(false);
  const successmsg = showSuccessmsg ? success4 : null;
  const [serviceOptions, setServiceOptions] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  // const [roleService,setRoleService]=useState([]);
  //   const [showSuccessmsg, setShowsuccessmsg] = useState(false);
  // const successmsg = showSuccessmsg ? success6 : null;
  const [showSuccessmsg1, setShowsuccessmsg1] = useState(false);
  const successmsg1 = showSuccessmsg1 ? success6 : null;
  const [showSuccessmsg2, setShowsuccessmsg2] = useState(false);
  const successmsg2 = showSuccessmsg2 ? success9 : null;
  const [newNode, setNewNode] = useState(false);

  const typeRoleData = typeRoleDpd?.data?.map((item) => {
    return (
      {
        label: item.userType,
        value: item.userTypeID,
        key: item.i
      }
    )
  });

  const roleService = roleMenuInfo?.data.map((item) => {
    if (item.subMenu.length == 0) {
      return (
        {
          title: item.serviceName,
          key: item.entServiceId,
          type: "parent",
          children: []

        }
      )
    } else {
      return (
        {
          title: item.serviceName,
          key: item.entServiceId,
          type: "parent",
          children: item?.subMenu.map((itm) => {
            return (
              {
                title: itm.serviceName,
                key: itm.entServiceId,
                type: "child",
                // isLeaf:true
                children: []
              }
            )
          })
        }
      )
    }
  });
  useEffect(() => {
    let c = [];
    if (assSrvInfo?.data) {
      for (let i = 0; i < assSrvInfo?.data.length; i++) {
        if (assSrvInfo.data[i].isAssociate == true && assSrvInfo.data[i].subMenu == 0) {
          c.push(assSrvInfo.data[i].entServiceId.toString());

        } else {
          if (assSrvInfo.data[i].isAssociate == true) {
            c.push(assSrvInfo.data[i].entServiceId.toString());
            let d = assSrvInfo.data[i].subMenu;
            for (let j = 0; j < d.length; j++) {
              if (d[j].isAssociate == true) {
                c.push(d[j].entServiceId.toString());
              }
            }
          }
        }
      }
    }
    setSelectedService(c);
  }, [assSrvInfo]);

 

  useEffect(()=>{
    if(assSrvInfo){
      const filteredArray = assSrvInfo?.data?.filter(
        (item) => item.isAssociate && item.subMenu !== null
      );
     
    }

  },[assSrvInfo]);

  const roleService1 = assSrvInfo?.data?.map((item) => {
    if (item.subMenu.length == 0) {
      return (
        {
          title: item.serviceName,
          key: item.entServiceId,
          type: "parent",
          children: []

        }
      )
    } else {
      return (
        {
          title: item.serviceName,
          key: item.entServiceId,
          type: "parent",
          children: item?.subMenu.map((itm) => {
            return (
              {
                title: itm.serviceName,
                key: itm.entServiceId,
                type: "child",
                // isLeaf:true
                children: []
              }
            )
          })
        }
      )
    }
  });
  const rolServ = roleMenuInfo?.data.map((item) => {
    if (item.subMenu.length == 0) {
      return (
        {
          title: item.serviceName,
          key: item.entServiceId,
          type: "parent",
          children: []

        }
      )
    } else {
      return (
        {
          title: item.serviceName,
          key: item.entServiceId,
          type: "parent",
          children: item?.subMenu.map((itm) => {
            return (
              {
                title: itm.serviceName,
                key: itm.entServiceId,
                type: "child",
                // isLeaf:true
                children: []
              }
            )
          })
        }
      )
    }
  });


  useEffect(() => {
    if (successmsg) {
      // message.success("User Group created successfully");
      message.success(addGroupInfo?.message);
      getUserGroupList(searchTableVal, pageIndex, pageSize, sortField, sortOrder);
      setShowsuccessmsg(false);

    }
  }, [successmsg]);

  useEffect(() => {
    if (successmsg1) {
      // if (successmsg1?.message == "UserGroup Associated with Users") {
      //   message.error(delGrpInfo.message);
      // } else {
      message.success("User Group status updated successfully");
      // }
      setShowsuccessmsg1(false);
      getUserGroupList(searchTableVal, pageIndex, pageSize, sortField, sortOrder);
    }
  }, [successmsg1]);

  useEffect(() => {
    if (successmsg2) {
      if (delGrpInfo?.message == "UserGroup Associated with Users") {
        // message.error(delGrpInfo.message);
        setOpenModal(true);
      } else {
        message.success("User Group deleted successfully");
        setOpenModal(false);
      }
      setShowsuccessmsg2(false);
      getUserGroupList(searchTableVal, pageIndex, pageSize, sortField, sortOrder);
    }
  }, [successmsg2]);

  const showDrawer = () => {
    setOpen(true);
    setUserGroupID(0);
    setRowData([]);
    setNewNode(false);
  };

  const onClose = () => {
    setOpen(false);
    setServiceOptions([]);
  };
  function getAssociatedServices(id) {
    dispatch(associateServices(id));
  }

  function getUserGroupList(search, page, pageSize, sortField, sortOrder) {
    let inputJson = {
      "UserGroupParams": {
        "TenantId": tenantID,
        "ProductId": productID
      },
      "ServerSearchables": {
        "draw": page,
        "searchData": search,
        "orderByColumn": sortField,
        "orderBy": sortOrder,
        "currentPage": page,
        "pageSize": pageSize,
        "pageNumber": page
      },
      "userGrpOrderLists": []
    }
    dispatch(userGroupGrid(inputJson));
  }
  useEffect(() => {
    getUserGroupList(searchTableVal, pageIndex, pageSize, sortField, sortOrder);
  }, []);

  const callbackFunction = (item) => {
    setShowDetail(item);
  }
  function userTypeRole() {
    let id = `${productID}/${tenantID}`;
    dispatch(userTypeRoleDpdn(id));
  }

  const columns1 = [
    {
      title: 'Group Name',
      dataIndex: 'userGroup',
      key: 'userGroup',
    },
    {
      title: 'User Type',
      dataIndex: 'userType',
      key: 'userType',
    },
    {
      title: 'User Role',
      dataIndex: 'roleName',
      key: 'roleName',
    },
    {
      title: 'Description',
      dataIndex: 'userGroupDesc',
      key: 'userGroupDesc',
    },
    {
      title: 'Status',
      dataIndex: 'userGroupStatus',
      key: 'userGroupStatus',
      render: (userGroupStatus, record) => {
        let checked = userGroupStatus == "Active" ? true : false;
        return (
          <div onClick={(event) => {
            event.stopPropagation(); 
            // setOpenStatus(true);
             setRowData(record);
            setGroupStatus(userGroupStatus == "Active" ? true : false)
          }}>
            {/* <Switch checked={checked} disabled /> */}
            <Popconfirm
            placement="topLeft"
            title="Are you sure you want to change the user Group status"
            onConfirm={() => updateGroupStatus(userGroupStatus)}
            okText="Yes"
            cancelText="No"
          >
              <Button className={`status-btn  ${userGroupStatus === 'InActive' ? 'selected' : ''}`} >{userGroupStatus}</Button>
            </Popconfirm>
            </div>
        )
      }
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',

      render: (id, record) => {
        return (
          <div>
            <Tooltip title="Edit User Group" className='mt-0'>
              <EditFilled className='me-2 text-success' onClick={(event) =>{updateUserGroup(record);event.stopPropagation();} } />
            </Tooltip>
           
              <Popconfirm
                placement="topLeft"
                title="Are you sure to remove this user group?"
                onConfirm={() => deleteUserGroup(record.userGroupID, true)}
                okText="Yes"
                cancelText="No"
              >
                <span><Tooltip title="Delete User Group" className='mt-0'> <DeleteFilled className='me-2 text-danger' onClick={(event) =>{event.stopPropagation();} } /></Tooltip></span>
              </Popconfirm>
            
            <Tooltip title="View User Details" className='mt-0'>
              <EyeOutlined className="text-primary" onClick={() =>{setShowDetail(true); setRowData(record);}} />
            </Tooltip>

          </div>
        );
      }
    },
  ];

  const updateUserGroup = (value) => {
    setNewNode(false);
    if(value.userGroupStatus=="Active"){
      setGroupStatus(true);
    }else{
      setGroupStatus(false);
    }
    setUserGroupID(value.userGroupID);
    setRowData(value);
    getAssociatedServices(value.userGroupID);
    setOpen(true);
    let typeList = typeRoleDpd.data;
    let d = [];
    for (let i = 0; i < typeList.length; i++) {
      if (typeList[i].userTypeID == value.userTypeID) {
        for (let j = 0; j < typeList[i].roles.length; j++) {
          d.push({
            label: typeList[i].roles[j].roleName,
            value: typeList[i].roles[j].roleId,
            key: typeList[i].roles[j].roleId
          })
        }
      }
    }
    setRoleOptions(d);
    form.setFieldsValue({
      userGroupName: value.userGroup,
      userGroupStatus: value.userGroupStatus == "Active" ? true : false,
      description: value.userGroupDesc,
      userType: value.userTypeID,
      userRole: value.roleID
    })
  }
  const handleCancel = () => {
    setOpen(false);
    setNewNode(false);
  };

  useEffect(() => {
    if (tenantID) {
      userTypeRole();
    }
  }, [tenantID]);

  const handleTypeChange = (val) => {
    let d = [];
    let typeList = typeRoleDpd.data;
    for (let i = 0; i < typeList.length; i++) {
      if (typeList[i].userTypeID == val) {
        for (let j = 0; j < typeList[i].roles.length; j++) {
          d.push({
            label: typeList[i].roles[j].roleName,
            value: typeList[i].roles[j].roleId,
            key: typeList[i].roles[j].roleId
          })
        }
      }
    }
    setRoleOptions(d);
  }
  const handleRoleChange = (val) => {
    setNewNode(true);
    dispatch(roleMenuService(val));
  }

  const submitUserGroup = (values) => {
    let s=selectedService;
    if(newNode){
    for(let i=0;i<rolServ.length;i++){
      if(rolServ[i].children.length>0){
        for(let j=0;j<rolServ[i].children.length;j++){
          if(selectedService.length>0){
            for(let k=0;k<selectedService.length;k++){
              if(selectedService[k]==rolServ[i].children[j].key){
               s.push(rolServ[i].key);
              }
            }
          }
        }
      }
    }
  }else{
    for(let i=0;i<roleService1.length;i++){
      if(roleService1[i].children.length>0){
        for(let j=0;j<roleService1[i].children.length;j++){
          if(selectedService.length>0){
            for(let k=0;k<selectedService.length;k++){
              if(selectedService[k]==roleService1[i].children[j].key){
               s.push(roleService1[i].key);
              }
            }
          }
        }
      }
    }
  }
    const uniqueArray=[...new Set(s)];
    let inputJson = {
      "UserGroupID": userGroupID,
      "UserGroup": values.userGroupName,
      "UserGroupDesc": values.description,
      "UserGroupStatus": groupStatus == true ? "Active" : "InActive" || "Active",
      "CreatedBy": localStorage.getItem('appUserID'),
      "TenantID": tenantID,
      "ProductID": productID,
      "UserTypeID": values.userType,
      "RoleID": values.userRole,
      "EntServices": uniqueArray ? uniqueArray.toString() : ""
    }
    console.log("INput sjons", inputJson, selectedService);
    dispatch(addUserGroup(inputJson));
    setShowsuccessmsg(true);
    // setServiceOptions([]);
    onClose();
  }

  const deleteUserGroup = (id, val) => {
    setUserGroupID(id);
    let inputJson = {
      "UserGroupID": id,
      "TenantID": tenantID,
      "ProductID": productID,
      "IsAvailable": val
    }
    dispatch(deleteUserGrp(inputJson));
    setShowsuccessmsg2(true);
    
  }

  const confirmDelGroup=()=>{

  }

  const closeOpenStatus = () => {
    setOpenStatus(false);
  }
  const onChangeStatus = (checked) => {
    setGroupStatus(checked);
  }
  const updateGroupStatus = (status) => {
    let inputJson = {
      "UserGroupID": rowData.userGroupID,
      "UserGroupStatus": status  == "Active" ? "InActive" : "Active",
      "TenantID": tenantID,
      "ProductID": productID
    }
    dispatch(changeGroupStatus(inputJson));
    setShowsuccessmsg1(true);
    closeOpenStatus();
  }
  // "UserGroupStatus": groupStatus == true ? "Active" : "InActive",
  const renderTreeNodes = (data) =>
    data.map((item) => {
      if (item.children) {

        return (
          <TreeNode className={`${item.type} bg-white`}
            key={item.key}
            title={
              <div className="row w-100 m-0">
                <div className="col-auto">
                  {item.title}
                </div>
                <div className="col-auto ms-auto pe-1">
                  {/* <PlusOutlined className="plus-icon bg-primary text-white" /> */}
                </div>
              </div>
            }
          >
            {renderTreeNodes(item.children)}
          </TreeNode>
        );
      }

      return (<TreeNode className={`${item.type}`} key={item.key} title={item.title} />);
    });

  const onCheck = (checkedKeys, info) => {
    console.log("ONCHECKL", checkedKeys, info);
    setSelectedService(checkedKeys.checked);
  }
  const onSelect = (selectedKeysValue) => {
    console.log('onSelect', selectedKeysValue);
    // setSelectedKeys(selectedKeysValue);
  };

  const handleTableChange = (pagination, ...sorted) => {
    let sort = "";
    if (sorted[1].order === "ascend") {
      sort = "asc";
    } else sort = "desc";
    setPageIndex(pagination.current);
    setSortField(sorted[1].field);
    setSortOrder(sort);
    getUserGroupList(searchTableVal, pagination.current, pagination.pageSize, sorted[1].field, sort);
  }

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      setSearchTableVal(e.target.value);
      setPageIndex(1);
      getUserGroupList(e.target.value, 1, pageSize, sortField, sortOrder);
    }
  }
  const resetSearch = (e) => {
    if (e.key === "Backspace" && !e.target.value) {
      setSearchTableVal("");
      setPageIndex(1);
      getUserGroupList(e.target.value, 1, pageSize, sortField, sortOrder);
    }
  }

  const closeModal=()=>{
    setOpenModal(false);
  }
  

  return (
    <>
      <div className="mt-2 ">
        {showDetail ?
          <ViewUserGroup data={{ rowData: rowData, callbackFunction: callbackFunction, isDefault:isDefault}} /> :
          <Card className="border-0">
            <div className='row ps-4 pe-3 mb-2'>
              <div className='col text-start ms-1 my-auto'>
                <h6 className="mb-0">List of User Groups</h6>
              </div>
              <div className='col-3 ps-0'>
                <div className='row right-side pe-0'>
                  <div className='col-md pe-0'>
                    <Input size='default' placeholder='search' onKeyDown={(e) => handleSearch(e)}
                      onKeyUp={(e) => resetSearch(e)} prefix={<SearchOutlined />} ></Input>
                  </div>
                  <div className='col-md-auto ps-2 pe-3'>
                  <Tooltip title="Add User Group" className='mt-0'>
                    <Button size='default' className="add-btn pe-2 border-0 " icon={<UserAddOutlined />} onClick={() => { showDrawer(); form.resetFields(); }}>  </Button>
                  </Tooltip>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-2">
              <Table className="entitlement-table" rowKey="userGroupID" columns={columns1} dataSource={tableData}
                loading={loading}
                onChange={handleTableChange}
                onRow={(record, rowIndex) => {
                  return {
                    onClick: event => {
                      setShowDetail(true);
                      setRowData(record);
                      setIsDefault(record.isSystem)
                      // console.log(record.isSystem, "table grid")
                    },
                  };
                }}
                pagination={{
                  current: pageIndex,
                  pageSize: pageSize,
                  total: totalPage,
                  onChange: (page, pageSize) => {
                    setPageIndex(page);
                    setPageSize(pageSize);
                    getUserGroupList(searchTableVal, page, pageSize, sortField, sortOrder)
                  }
                }}
              /></div>
          </Card>
        }
      </div>

      <Drawer
        title="Add/Update User Group"
        width={550}
        onClose={onClose}
        open={open}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose={true}
        initialValues={{ userGroupStatus: true }}
      >
        <Form layout="vertical" onCancel={handleCancel} form={form} onFinish={submitUserGroup}>
          <div className=' row mx-0 mt-2 border-0 '>
            <Card className="border-0 p-0">
              <div className='row mt-1'>
                <Form.Item label="User Type" name='userType' >
                  <Select options={typeRoleData} onChange={handleTypeChange} />
                </Form.Item>
                <Form.Item label="User Role" name='userRole' >
                  <Select options={roleOptions} onChange={handleRoleChange} />
                </Form.Item>
              </div>
              <div className='row '>
                <Form.Item label="User Group Name" name='userGroupName' className='col-md-8'>
                  <Input />
                </Form.Item>
                <Form.Item label="User Group Status" name='userGroupStatus' className='col-md-4'>
                  <Switch checked={groupStatus}
                    onChange={onChangeStatus}
                  // onChange={onChange} 
                  />
                </Form.Item>
              </div>
              <div className="row">
                <Form.Item label="Description" name='description' >
                  <TextArea />
                </Form.Item>
              </div>

              {/* <div>
                {userGroupID != 0 ? <>
                  {roleService1 ?
                    <div className="green-tree">
                      <Tree
                        checkable
                        checkStrictly
                        defaultExpandAll
                        defaultCheckedKeys={selectedService}
                        // onSelect={onSelect}
                        onCheck={onCheck}
                        className="draggable-tree1"
                        // treeData={roleService}
                        blockNode>{renderTreeNodes(roleService1)}</Tree>
                    </div> : ""
                  }
                </> : <>

                  {newNode && rolServ ?
                    <div className="green-tree">
                      <Tree
                        checkable
                        checkStrictly
                        defaultExpandAll
                        onSelect={onSelect}
                        onCheck={onCheck}
                        className="draggable-tree1"
                        blockNode>{renderTreeNodes(rolServ)}</Tree>
                    </div> : ""}
                </>}
              </div> */}

              <div className="mt-4 text-end">
                <Button type="primary ms-auto cancel-btn" className="me-2 col-auto ms-auto dlv-cancel-btn" onClick={onClose} danger>Cancel</Button>
                <Button type="primary" htmlType="submit" className="me-0 col-auto dlv-save-btn" >Save</Button>
              </div>
            </Card>
          </div>
        </Form>
      </Drawer>
      {/* enable disable user group */}
      <Drawer
        title="Enable/Disable User Group"
        width={550}
        onClose={closeOpenStatus}
        open={openStatus}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose={true}
      >
        <div className="bg-blue p-3 mb-3">
          <div><span className="fw-bold">Group Name:</span> <span>{rowData?.userGroup}</span></div>
          <div><span className="fw-bold">Group Description:</span> <span>{rowData?.userGroupDesc}</span></div>
          <div className="d-flex">
            <div><span className="fw-bold">User Type:</span> <span>{rowData?.userType}</span></div>
            <div><span className="fw-bold">User Role:</span> <span>{rowData?.roleName}</span></div>
          </div>
        </div>
        <Switch defaultChecked={groupStatus}
          onChange={onChangeStatus}
        />
        <div className="mt-4 text-end">
          <Button type="default" onClick={closeOpenStatus} className="me-2 col-auto ms-auto" danger>Cancel</Button>
          <Button type="primary" className="me-0 col-auto" onClick={updateGroupStatus} >Update</Button>
        </div>
      </Drawer>
      <Modal title="Delete User Group" open={openModal} onOk={()=>deleteUserGroup(userGroupID,false)} onCancel={() => closeModal()}>
        <Divider className="mb-3 mt-1" />
        <span>This UserGroup is Associated with Users<br/>
          Do you still want to delete ?</span>
      </Modal>
    </>

  )
}


